import React, {Component} from 'react';

import ContentThumbnail from './content_thumbnail';

import contentData from './endless_possibilities_info';

export default class EndlessPossibilities extends Component {
    constructor(){
        super();
        this.setClasses = this.setClasses.bind(this);
        this.displayThumbnails = this.displayThumbnails.bind(this);
    }

    setClasses(){
        const {page} = this.props;

        return page === 'brand-ambassadors' ? 'gr-12 endless-possibilities brand-ambassadors-endless-possibilities' : 'gr-12 endless-possibilities branded-content-endless-possibilities'
    }

    displayThumbnails(){
        const {displayStatic} = this.props;

        return contentData.map((content, idx) => {
            return <ContentThumbnail
                key={idx}
                type={content.type}
                caption={content.caption}
                contentFormat={content.contentFormat}
                contentPath={content.contentPath}
                videoContentPath={content.videoContentPath}
                displayStatic={displayStatic} />
        });
    }

    render(){
        const classes = this.setClasses();
        const thumbnails = this.displayThumbnails();

        return(
            <div className={classes}>
                <div className='endless-possibilities-text'>
                    <h1>Endless Possibilities</h1>
                    <p>Imagine a future where content is no longer a constraint.</p>
                </div>
                <div className='endless-possibilities-grid'>
                    {thumbnails}
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./web/js/components/endless_possibilities/index.js